import React from 'react';
import classNames from 'classnames';
import { Content, Flex, Pane, Text } from '@leverege/ui-elements';
import { TitleBar, Toolbar } from '@leverege/ui-plugin';
import AbstractMissingRelationshipScreen from "./AbstractMissingRelationshipScreen.js";
import S from './Shared.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class DesktopMissingRelationshipScreen extends AbstractMissingRelationshipScreen {
  constructor(props) {
    super(props);
    this.mobile = false;
    this.matchContext.mobile = false;
  }
  render() {
    return /*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsx(Content.Header, {
        children: /*#__PURE__*/_jsxs(TitleBar, {
          variant: "screenTitle",
          title: this.getName(),
          icon: this.getIcon(),
          children: [/*#__PURE__*/_jsx(Toolbar, {
            variant: "actionBar",
            hasContextMenu: true,
            prefer: "icon",
            matchContext: {
              ...this.matchContext,
              use: 'actionBar'
            },
            context: this.getContext()
          }), /*#__PURE__*/_jsx(Flex, {
            align: "center",
            children: /*#__PURE__*/_jsx(Toolbar, {
              variant: "layoutActionBar|actionBar",
              prefer: "icon",
              matchContext: {
                ...this.matchContext,
                use: 'layoutActionBar'
              },
              mustMatchContext: {
                use: 'layoutActionBar'
              },
              context: this.getContext()
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        children: /*#__PURE__*/_jsxs(Pane, {
          variant: "noDataView",
          className: classNames(S.win, S.noDataContainer),
          layout: "flex:rowL",
          children: [/*#__PURE__*/_jsx("img", {
            className: S.image,
            src: this.getImageSource(),
            alt: "noData"
          }), /*#__PURE__*/_jsx(Pane, {
            variant: "noDataBody",
            children: /*#__PURE__*/_jsx(Flex, {
              variant: "colXL",
              justify: "center",
              vFill: true,
              children: /*#__PURE__*/_jsxs(Pane, {
                variant: "noDataContent",
                layout: "flex:colL",
                children: [/*#__PURE__*/_jsx(Text, {
                  variant: "sectionTitle",
                  children: this.getTitle()
                }), /*#__PURE__*/_jsxs(Text, {
                  variant: "sectionBody",
                  children: [this.getSubtitle(), " "]
                }), /*#__PURE__*/_jsx(Toolbar, {
                  variant: "missingRelationship",
                  matchContext: {
                    ...this.matchContext,
                    use: 'missingRelationship'
                  },
                  context: this.getContext()
                })]
              })
            })
          })]
        })
      })]
    });
  }
}
export default DesktopMissingRelationshipScreen;